export interface Item {
    REMARKS: string;
    STATE: string;
    NAME?: string;
    DESCRIPTION: string;
    EDIT_DATETIME: Date;
    TAG_UID: string;
    LOCATION: string;
    USERNAME?: string;
    USERSURNAME?: string;
    STATUS?: string;
    TITLE?: string;
    MARK?: string;
    CATEGORY?: string;
    PURCHASE_DATE: Date;
  }

export enum FieldType {RFIDNumber, EvidNumber, Title, Description, Category, Mark, PurchaseDate, Size, State,
    Location, Remarks, Miniature, Photos, Link, LinkedFileds, LastUser, LastEntry, Status, UserName, UserSurname}

export interface MessageItem {
    CONTENT?: string;
    TITLE?: string;
    TYPE?: string;
    KEY?: string;
    CONFIRMED: boolean;
  }

export interface TagItem {
    CATEGORY?: string;
    DESCRIPTION?: string;
    EDIT_DATETIME?: Date;
    MARK?: string;
    LINK?: string;
    PURCHASE_DATE?: Date;
    TYPE?: string;
    REG_NUM?: string;
    SIZE?: string;
    TAG_UID?: string;
    USER_ID?: string;
    TITLE?: string;
    PHOTO?: string;
    LINKED_FIELDS?: Array<string>;
  }

export interface EventItem {
    LOCATION?: string;
    REMARKS?: string;
    EVENT_DATETIME?: Date;
    STATE?: string;
    TAG_UID?: string;
    USER_ID?: string;
    PHOTOS?: Map<string, string>;
    COORD?: Map<string, Map<string, number>>;

  }

export interface LocationItem {
    ADDRESS?: string;
    INVENTORY_DATE?: Date;
    INVENTORY_STATUS?: string;
    MAP?: Map<string, string>;
    NAME?: string;
    PREVIOUS_INVENTORY?: Map<string, string>;
    SIZE?: string;
    LOCATION_ID?: string;
  }

export interface UserItem {
  ID?: string;
  NAME?: string;
  SURNAME?: string;
  LOGIN?: string;
  PASSWORD?: string;
  DEV_ID?: string;
  TYPE?: string;
  ROLE?: string;
  EXPIRATION_DATE?: Date;
}
